import { observable } from "mobx";
import { Type } from "class-transformer";
import ReportRequestStatus from "./reportRequestStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExternalReportResponse {
  id!: string;

  @observable
  createdBy!: string;

  @observable
  @Type(() => Date)
  processedAt?: Date;

  @observable
  reportName!: string;

  @observable
  status!: ReportRequestStatus;
}
